export default {
  SET_LIST(state, list) {
    state.list = list.rows
    state.total = list.total
    state.page = list.page
  },
}
